module.exports = __webpack_public_path__ + "files/063a9bdba5b81d4f6210ff47cc086351.png";


//////////////////
// WEBPACK FOOTER
// ./images/browsers/firefox.png
// module id = 799
// module chunks = 0